<template>
  <div :class="'image-picker '+(extraClass?extraClass:'')">
    <img class="img-preview no-select" :src="(url?url:'/assets/img/image-icon.png')" draggable="false" />
    <input class="attachment-id" type="hidden" :name="name" :value="id" />
  </div>
</template>

<script>
export default {
name: "ImagePicker",
  props:[
      'id',
      'name',
      'url',
      'extraClass'
  ]
}
</script>

<style scoped>

</style>